<template>
  <div class="bomter">
    <div class="main">
      <div class="logo"></div>
      <div class="text-left">
        <span>关于隆携 | 产品介绍 新闻资讯</span>
      </div>

    </div>
    <div class="bom">
      <div class="text-left">
        <span>地址：重庆市九龙坡区科园一路30号14层1402号</span>
      </div>
      <div>
        <span>Copyright © 2018-2020 重庆隆携小额贷款有限公司</span>
        <span @click="beianClickS" class="text-center">
          <img src="../../assets/警徽.jpg" style="height: 15px;"/>
          渝公网安备 50010702504367号
        </span>
        <span> | </span>
        <span @click="beianClick" class="text-center">渝ICP备2022004260号-1</span>
      </div>
      <div class="bank">
        <div class="img-1"></div>
        <div class="img-2"></div>
        <div class="img-3"></div>
      </div>
<!--      <div class="ov">-->
<!--        <div class="img-4"></div>-->
<!--        <div class="img-5"></div>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "bomter",
  methods: {
    beianClick() {
      window.open("https://beian.miit.gov.cn/#/Integrated/index", "_blank");
    },
    beianClickS() {
      window.open("http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=50010702504367", "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.bomter {
  width: 100%;
  overflow: hidden;

  .main {
    display: flex;
    padding: 0 20px;

    .logo {
      width: 160px;
      height: 60px;
      background: url("../../assets/隆携logo.png") center center no-repeat;
      background-size: 100% 100%;
    }

    .text-left {
      position: relative;
      width: 200px;
      height: 48px;
      cursor: pointer;

      span {
        width: 200px;
        position: absolute;
        color: #0066ff;
        bottom: 0;
        left: 0;
        font-size: 14px;
      }
    }
  }

  .bom {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    padding: 0 20px;
    align-items: center;

    .text-center {
      cursor: pointer;
    }

    .text-center:hover {
      color: #0066ff;
    }
  }

  .bank {
    display: flex;
    position: relative;

    &::after {
      content: "合作银行";
      position: absolute;
      font-size: 14px;
      color: #0066ff;
      top: -30px;
      left: 30%;
    }

    .img-1 {
      width: 50px;
      height: 45px;
      background: url("../../assets/ICBC银行.jpg") center center no-repeat;
      background-size: contain;
    }

    .img-2 {
      width: 50px;
      height: 45px;
      background: url("../../assets/民生银行.jpg") center bottom no-repeat;
      background-size: 100%;
    }

    .img-3 {
      width: 100px;
      height: 45px;
      background: url("../../assets/浦发银行.jpg") center top no-repeat;
      background-size: 95%;
    }
  }

  .ov {
    display: flex;
    position: relative;

    &::after {
      content: "合作伙伴";
      position: absolute;
      font-size: 14px;
      color: #0066ff;
      top: -30px;
      left: 30%;
    }

    .img-4 {
      width: 80px;
      height: 45px;
      background: url("../../assets/VIVO图标.jpg") center top no-repeat;
      background-size: 100%;
    }

    .img-5 {
      width: 90px;
      height: 45px;
      background: url("../../assets/OPPO图标.jpg") center center no-repeat;
      background-size: auto 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Bomter/index.vue